import {
    addContainerClassesNoRules,
    multiClasses,
} from '@dat/iq-style-processor';
import { Dashboard, Section } from '../../models';
import { idCreator } from '../../models/builder-utils';
import {
    AboutTrendlinesComponents,
    AdditionalInformationComponents,
    NationalSpotRatesComponents,
    ViewFuelPriceComponents,
    ViewHeaderComponents,
    ViewTitleComponents,
    WeeklyBriefComponents,
    WeeklySnapshotComponents,
} from './view-trends-components.models';
import { CenteredSectionClasses } from './shared.models';
enum DatiqRulesConditionOperators {
    And = 'and',
    Or = 'or',
    Not = 'not',
}
const idRoot = `tl-trends`;

export const WeeklySnapshotSection: Section = {
    id: `view-trends-weekly-snapshot`,
    components: [
        ...WeeklySnapshotComponents(idCreator(idRoot, ['weekly-snapshot'])),
    ],
    classNames: {
        ...addContainerClassesNoRules(['bg-transparent']),
        ...multiClasses(
            [
                '!bg-transparent',
                'mt-[100px]',
                'max-w-[1140px]',
                'mx-auto',
                '!border-0',
                'bg-black',
            ],
            ['[data-uitype="builder-section"]'],
        ),
        ...multiClasses(
            ['!bg-transparent', '!border-none'],
            ['[data-uitype="section-header"]'],
        ),
    },
};
export const NationalSpotRatesSection: Section = {
    id: idCreator(idRoot, ['national-spot-rates']),
    components: [
        ...NationalSpotRatesComponents(
            idCreator(idRoot, ['national-spot-rates']),
        ),
    ],
    classNames: {
        ...multiClasses(
            [
                '!bg-transparent',
                'mt-[100px]',
                'max-w-[1140px]',
                'mx-auto',
                'grid',
                'grid-cols-3',
                'sm:grid-cols-1',
                'gap-x-2',
                'gap-y-4',
                'sm:justify-items-center',
            ],
            ['[data-uitype="builder-section"]'],
        ),
        ...multiClasses(
            ['col-span-3'],
            [
                `[data-styletarget="${idCreator(idRoot, [
                    'national-spot-rates',
                    'label',
                ])}"]`,
            ],
        ),
       
    },
};

export const WeeklyBriefSection: Section = {
    id: idCreator(idRoot, ['weekly-brief']),
    components: [...WeeklyBriefComponents(idCreator(idRoot, ['weekly-brief']))],
    classNames: {
        ...addContainerClassesNoRules([
            '!iq-bg-trendlines-map',
            'flex',
            'justify-center',
            'items-center',
            '!w-full',
            'mt-[100px]',
        ]),
        ...multiClasses(
            [
                '!bg-transparent',
                'py-[100px]',
                'max-w-[1140px]',
                // 'relative',
                'grid',
                'grid-cols-4',
                'grid-rows-[100px_minmax(0,1fr)]',
                'sm:grid-cols-1',
                'tablet:grid-cols-1',
                'tablet:grid-rows-[100px_minmax(0,1fr)_minmax(0,1fr)]',
                // 'grid-rows-[auto_300px]',
                // 'sm:grid-rows-[auto_400px]',
                'tablet:px-[25px]',
            ],
            ['[data-uitype="builder-section"]'],
        ),
        ...multiClasses(
            [
                'col-span-3',
                '!bg-black',
                'py-5',
                'pl-[35px]',
                'pr-[50px]',
                'w-full',
            ],
            [
                `[data-styletarget="${idCreator(idRoot, [
                    'weekly-brief',
                    'header',
                ])}"]`,
            ],
        ),
    },
};

export const ViewTitleSection: Section = {
    id: idCreator(idRoot, ['title']),
    components: [...ViewTitleComponents(idCreator(idRoot, ['title']))],
    classNames: {
        ...addContainerClassesNoRules(['bg-transparent']),
        ...multiClasses(
            ['!bg-transparent', 'max-w-[1140px]', 'mx-auto', 'pt-[50px]'],
            ['[data-uitype="builder-section"]'],
        ),
    },
};

export const ViewHeaderSection: Section = {
    id: idCreator(idRoot, ['header']),
    components: [...ViewHeaderComponents(idCreator(idRoot, ['title']))],
    classNames: {
        ...addContainerClassesNoRules(['bg-transparent']),
        ...multiClasses(
            ['!bg-transparent', 'max-w-[1140px]', 'mx-auto'],
            ['[data-uitype="builder-section"]'],
        ),
    },
};

export const ViewFuelPrices: Section = {
    id: idCreator(idRoot, ['fuel-prices']),
    components: [
        ...ViewFuelPriceComponents(idCreator(idRoot, ['fuel-prices'])),
    ],
    classNames: {
        ...addContainerClassesNoRules(['bg-transparent']),
        ...multiClasses(
            ['!bg-transparent', 'mt-[100px]', 'max-w-[1140px]', 'mx-auto'],
            ['[data-uitype="builder-section"]'],
        ),
    },
};

export const AdditionalInformation: Section = {
    id: idCreator(idRoot, ['additional-information']),
    components: [
        {
            id: idCreator(idRoot, ['additional-information','header']),
            type: 'Label',
            props: {
                label: `<h2 class="tl-section-header text-white m-0 mb-10 sm:px-[25px]">Want More?</h2>`,
            },
            classNames: {
            },
        },
        ...AdditionalInformationComponents(
            idCreator(idRoot, ['additional-information']),
        ),
    ],
    classNames: {
        ...addContainerClassesNoRules([
            '!iq-bg-blue-highway',
            'flex',
            'justify-center',
            'items-center',
            '!w-full',
            'mt-[100px]',
        ]),
        ...multiClasses(
            [
                'bg-[black_!important]',
                'max-w-[970px]',
                'relative',
                'grid',
                'w-full',
                'px-[120px]',
                'sm:px-[25px]',
                'm-[100px]',
                'sm:m-[20px]',
                'py-[80px]',
                'tablet:py-[50px]',
                'grid-cols-1',
                'gap-x-2',
                '!border-0',
            ],
            ['[data-uitype="builder-section"]'],
        ),
        ...multiClasses(
            ['col-span-1', 'w-full', '!bg-black'],
            [
                `[data-styletarget="${idCreator(idRoot, [
                    'additional-information',
                    'label',
                ])}"]`,
            ],
        ),
    },
};

export const AboutTrendlinesSection: Section = {
    id: idCreator(idRoot, ['about-trendlines']),
    components: [
        {
            id: idCreator(idRoot, ['about-trendlines','header']),
            type: 'Label',
            props: {
                label: `<h2 class="tl-section-header tl-about-title m-0 mb-10">About Trendlines</h2>`,
            },
            classNames: {
            },
        },
        ...AboutTrendlinesComponents(idCreator(idRoot, ['about-trendlines'])),
    ],
    classNames: {
        ...CenteredSectionClasses,
        ...multiClasses(
            ['my-[100px]', 'sm:px-[25px]','tablet:px-[25px]'],
            ['[data-uitype="builder-section"]'],
        ),
    },
};
export const EditTrendsSection: Section = {
    id: idCreator(idRoot, ['edit-trendlines']),
    title: '',
    classNames: {
        ...multiClasses(
            ['fixed', 'top-0', 'm-4', 'z-50', 'w-1/2', '!bg-transparent'],
            ['[data-uitype="builder-section"]'],
        ),
    },
    components: [
        {
            id: idCreator(idRoot, ['edit-trendlines', 'content']),
            type: 'TrendlinesContentViewTrends',
            rules: [
                {
                    conditionOperator: DatiqRulesConditionOperators.And,
                    // conditions: [
                    //     {
                    //         type: 'featureFlag',
                    //         key: 'Enabled',
                    //         is: 'equals',
                    //         value: ['iq_com_trendlines_content_view_trends'],
                    //     },
                    // ],
                },
            ],
        },
    ],
};
export const ViewTrendsDashboard: Dashboard = {
    id: idCreator(idRoot, ['dashboard']),
    sections: [
        EditTrendsSection,
        ViewTitleSection,
        ViewHeaderSection,
        WeeklySnapshotSection,
        NationalSpotRatesSection,
        WeeklyBriefSection,
        ViewFuelPrices,
        AdditionalInformation,
        AboutTrendlinesSection,
    ],
    classNames: {
        ...addContainerClassesNoRules([
            'w-full',
            'h-full',
            'mt-[50px]',
            'sm:overflow-x-hidden',
        ]),
    },
};
